import { META } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#0D0B0A] text-[#F8F4ED] mt-24 border-t border-[#2A241F]">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-[1.5fr_1fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif italic text-4xl">{META.brand}</p>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#F59E0B] mt-2" dangerouslySetInnerHTML={{ __html: META.tag }} />
          <p className="font-sans text-sm text-[#F8F4ED]/55 mt-5 leading-[1.7] max-w-md">An institutional digital-asset desk with $4.8B in custody, 47 active LPs, and a published house-thesis. Authorised & regulated; client funds segregated.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#F59E0B] mb-3">Desk</p>
          <ul className="space-y-2 font-sans text-sm text-[#F8F4ED]/85"><li><button onClick={() => setPage('tape')} className="hover:text-[#F59E0B]">Live tape</button></li><li><button onClick={() => setPage('thesis')} className="hover:text-[#F59E0B]">House thesis</button></li><li><a className="hover:text-[#F59E0B]" href="#">FIX 4.4 docs</a></li></ul>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#F59E0B] mb-3">Compliance</p>
          <ul className="space-y-2 font-sans text-sm text-[#F8F4ED]/85"><li>MTF licence #482-INST</li><li>SOC2 Type II · 2024</li><li>Marsh insurance · $400M</li></ul>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#F59E0B] mb-3">Offices</p>
          <p className="font-sans text-sm text-[#F8F4ED]/85 leading-[1.65]">London · Singapore<br />New York · Zürich</p>
        </div>
      </div>
      <div className="border-t border-[#2A241F] px-6 lg:px-10 py-4 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#F8F4ED]/40"><span>© 2026 {META.brand} · Inst. Only · Not for retail distribution</span><span>desk@aether.markets</span></div>
    </footer>
  );
}
